export const color = {
    primary: window.color.searchBoxBgColor || '#004F9E',
    secondary: window.color.buttonColor || '#F15A22',
    defaultBoarderColor: '#220020',
    inputborderColor: '#757575',
    defaultInputColor: '#666',
}

export const bookStatus = {
    B: 'BOOKED',
    C: 'CANCELLED',
}

export const apiUrl = {
    // GET ? mobile | otptype=LG
    generateOTP: '/api/resource/GenerateOTP',
    // GET ? OTP | otptype=LG
    validateOTP: "/api/resource/APIValidateAgentOTP",
    // GET ? SEARCHVAL | SEARCHMODE | DAYS 
    statusDetails: '/api/resource/statusDetails',

    // GET ? SEARCHVAL | SEARCHMODE | DAYS 
    tripStatusDetails: '/api/resource/tripStatusDetails',
    // GET ? MOBILE NO 
    // getOrderStausFromMobileNo: '/api/resource/getOrderStausFromMobileNo',

    // getOrderStausFromEmailId: '/api/resource/getOrderStausFromEmailId',

    // getOrderStausFromUTR: '/api/resource/getOrderStausFromUTR',
    // GET ? emailId
    generateOTPFromEmailId: '/api/resource/generateFourDigitNumber',
    // GET ? emailId | otp
    // sendOtpEmail: '/api/resource/sendOtpEmail',

    sendOtpEmail: '/api/resource/generateEmailOTP',
    validateOtpEmail: '/api/resource/validateEmailOTP',

    // GET ? PNR NO 
    getBookingInfo: '/api/resource/BookingInfoAndOrderId',

    // POST
    viewBooking: '/ticket/viewbooking',

    //GET
    getcountryCode: '/api/resource/countryCode',
    bookingInfoV3: "/api/resource/BookingInfoV3",

}